import AiIcon from '../AIIcon';
import { Tag } from '../ui';

const MATCH_TAG_COLORS: any = {
  15: 'yellow',
  50: 'blue',
  90: 'green',
  100: 'green'
} as const;

// This is V2
// const MATCH_TAG_COLORS: any = {
//   16: 'red',
//   50: 'yellow',
//   90: 'green',
//   100: 'flat'
// } as const;

type MatchColor = (typeof MATCH_TAG_COLORS)[keyof typeof MATCH_TAG_COLORS];

interface MatchTagProps {
  score?: number;
  recommended?: boolean;
}

const getColorFromScore = (score: number): MatchColor => {
  const thresholds = Object.keys(MATCH_TAG_COLORS)
    .map(Number)
    .sort((a, b) => a - b); // [15, 50, 90, 100]

  let matchedThreshold = thresholds[0];

  for (const threshold of thresholds) {
    if (score >= threshold) {
      matchedThreshold = threshold;
    } else {
      break;
    }
  }

  return MATCH_TAG_COLORS[matchedThreshold];
};

const MatchTag: React.FC<MatchTagProps> = ({ score, recommended }) => {
  if (recommended) {
    return (
      <Tag
        classNames={{ content: '!pl-1 pr-2' }}
        style={{
          background:
            'linear-gradient(105deg, #69DBFF -22.69%, #000EEF 160.49%)'
        }}
        color="default"
      >
        <div className="text-white flex items-center justify-center font-semibold gap-[2px]">
          <AiIcon /> Top pick
        </div>
      </Tag>
    );
  }

  if (score == null) {
    return (
      <Tag classNames={{ base: 'px-2' }} color="none">
        -
      </Tag>
    );
  }

  const color = getColorFromScore(score);

  return (
    <Tag classNames={{ base: 'px-2' }} color={color}>
      {score}%
    </Tag>
  );
};

export default MatchTag;
